import QueryString from 'qs';
import mainCaller from './mainCaller';

export const getAllMenu = async (token) => {
    return await mainCaller(`admin/api/v1/menus`, 'GET', null, {
        Authorization: `Bearer ${token}`,
    });
};


export const createOperator = async (data, token) => {
    return await mainCaller(`admin/api/v1/operators`, 'POST', data, {
        Authorization: `Bearer ${token}`,
    });
}
export const updateOperator = async (data, id, token) => {
    return await mainCaller(`admin/api/v1/operators/${id}`, 'PUT', data, {
        Authorization: `Bearer ${token}`,
    });
}

export const getOperatorList = async (query, token) => {
    const queryString = QueryString.stringify(query)
    return await mainCaller(`admin/api/v1/operators?${queryString}`, 'GET', null, {
        Authorization: `Bearer ${token}`,
    });
}

export const getOperatorById = async (id, token) => {
    return await mainCaller(`admin/api/v1/operators/${id}`, 'GET', null, {
        Authorization: `Bearer ${token}`,
    });
}

export const deleteOperators = async (query, token) => {
    return await mainCaller(`admin/api/v1/operators?${query}`, 'DELETE', null, {
        Authorization: `Bearer ${token}`,
    });
}

export const getUserMenuById = async (query, token) => {
    return await mainCaller(`admin/api/v1/menus/userMenuRelation?${query}`, 'GET', null, {
        Authorization: `Bearer ${token}`,
    });
}

export const updateUserMenuAuthRelation = async (data, token) => {
    return await mainCaller(`admin/api/v1/menus/userMenuRelation`, 'PUT', data, {
        Authorization: `Bearer ${token}`,
        "Content-type": "multipart/form-data"
    });
}